import { render, staticRenderFns } from "./Diversions.vue?vue&type=template&id=bc64d716&"
import script from "./Diversions.vue?vue&type=script&lang=js&"
export * from "./Diversions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports